import axios from "axios"

export default{
    MainGroup:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/maingroup/update' : '/api/shipableproduct/maingroup/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/maingroup/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/maingroup/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/maingroup/select/list')
            return response
        }
    },
    SubGroup:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/subgroup/update' : '/api/shipableproduct/subgroup/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/subgroup/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/subgroup/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/subgroup/select/list')
            return response
        }
    },
    Form:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/form/update' : '/api/shipableproduct/form/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/form/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/form/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/form/select/list')
            return response
        }
    },
    DangerClass:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/dangerclass/update' : '/api/shipableproduct/dangerclass/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/dangerclass/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/dangerclass/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/dangerclass/select/list')
            return response
        }
    },
    ValueClass:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/valueclass/update' : '/api/shipableproduct/valueclass/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/valueclass/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/valueclass/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/valueclass/select/list')
            return response
        }
    },
    LoadMode:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/loadmode/update' : '/api/shipableproduct/loadmode/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/loadmode/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/loadmode/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/loadmode/select/list')
            return response
        }
    },
    LoadType:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/loadtype/update' : '/api/shipableproduct/loadtype/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/loadtype/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/loadtype/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/loadtype/select/list')
            return response
        }
    },
    Product:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/shipableproduct/update' : '/api/shipableproduct/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/shipableproduct/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/shipableproduct/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/shipableproduct/select/list')
            return response
        },
        async GetById(id){
            const response = await axios.get(`/api/shipableproduct/get/${id}`)
            return response
        },
        async TreeList(){
            const response = await axios.get(`/api/shipableproduct/select/treelist`)
            return response
        }
    },
}